const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";
import * as types from "./mutation_types";

export const retrieve = ({ commit }, values) => {
  commit(types.LIGNE_ROB_SHOW_TOGGLE_LOADING);
  axios
    .get(
      URL_BACKEND +
        "api-ligne_rob/cartes/" +
        values.robId +
        "/" +
        values.ligne_robId +
        "/"
    )
    .then((response) => {
      commit(types.LIGNE_ROB_SHOW_TOGGLE_LOADING);
      commit(types.LIGNE_ROB_SHOW_SET_RETRIEVED, response.data);
    })
    .catch((e) => {
      commit(types.LIGNE_ROB_SHOW_TOGGLE_LOADING);
      commit(types.LIGNE_ROB_SHOW_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.LIGNE_ROB_SHOW_RESET);
};
